import { createElement, Fragment, type ReactNode } from 'react'

/**
 * Fill the `{name}` slots of one copy string with nodes (a link, a name), so a
 * sentence that carries a link stays one string in `src/copy/`
 * (internationalization: never build a sentence from fragments).
 */
export function fillSlots(
  template: string,
  slots: Record<string, ReactNode>,
): ReactNode[] {
  return template.split(/(\{[a-zA-Z]+\})/).map((part, i) => {
    const slot = /^\{([a-zA-Z]+)\}$/.exec(part)
    if (!slot || !(slot[1] in slots)) return part
    return createElement(Fragment, { key: i }, slots[slot[1]])
  })
}
